import { render, staticRenderFns } from "./DepositoForm.vue?vue&type=template&id=5b312421&scoped=true&"
import script from "./DepositoForm.vue?vue&type=script&lang=js&"
export * from "./DepositoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b312421",
  null
  
)

export default component.exports